import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {fetchJSON} from '../../../../helpers/FetchUtils';
import {
    TOP_BAR_LOAD
} from './constants';
import {
    loadTopBarFail,
    loadTopBarSuccess
} from './actions';
import {catchError, showErrorToast} from "../../../../util/ErrorCatchUtils";
import {layoutMainSignCheck} from "../main/actions";

//
function* loadTopBar() {
    try {
        const response = yield call(fetchJSON,
            '/api/account/member/current', {
            method: 'GET'
        });
        if (response.success) {
            yield put(loadTopBarSuccess({loadDatas: {...response.data}}));
        } else {
            // yield put(layoutMainSignCheck({...response, showToast: false}));
            yield put(loadTopBarFail(response));
        }
    } catch (error) {
        // yield put(layoutMainSignCheck(showErrorToast(error)));
        yield put(loadTopBarFail(catchError(error)));
    }
}

//
export function* loadTopBarWatcher() {
    yield takeEvery(TOP_BAR_LOAD, loadTopBar);
}

//
function* LayoutTopBarSaga() {
    yield all([
        fork(loadTopBarWatcher)]);
}

//
export default LayoutTopBarSaga;
